import React, { useState } from 'react';
import { FaInstagram } from 'react-icons/fa';
import vishal from '../../images/owners/vishal.JPEG'
import prateek from '../../images/owners/prateek.JPEG'
import pankanj from '../../images/owners/pankaj.JPEG';
import shivam from '../../images/owners/shivam.JPEG';
import mansi from '../../images/owners/mansi.jpg';

const teamData = [
  {
    img:`${pankanj}`,
    name: 'PANKAJ SHAH',
    designation: 'Co-founder of Swingtraderrs',
  },
  {
    img: `${shivam}`,
    name: 'SHIVAM RATHORE',
    designation: 'Founder of Swingtraderrs',
  },
  {
    img: `${mansi}`,
    name: 'MANSI VERMA',
    designation: 'Research Analyst',
  },
  {
    img: `${vishal}`,
    name: 'Vishal Kumar',
    designation: 'Tech Developer',
  },
  {
    img:  `${prateek}`,
    name: 'Prateek Verma',
    designation: 'Content & Social Media Expert',
  },
];

const Team = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [startPosition, setStartPosition] = useState(0);

  // Handling mouse and touch events
  const handleDragStart = (e) => {
    setIsDragging(true);
    setStartPosition(e.clientX || e.touches[0].clientX);
  };

  const handleDragEnd = () => {
    setIsDragging(false);
  };

  const handleDragMove = (e) => {
    if (!isDragging) return;

    const currentPosition = e.clientX || e.touches[0].clientX;
    const dragAmount = currentPosition - startPosition;

    if (dragAmount > 100 && currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
      setIsDragging(false);
    } else if (dragAmount < -100 && currentIndex < teamData.length - 3) {
      setCurrentIndex(currentIndex + 1);
      setIsDragging(false);
    }
  };

  return (
    <>
      <h2 className="text-center py-5">Meet Our Professionals</h2>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px',
        }}
      >
        <div
          style={{
            display: 'flex',
            overflow: 'hidden',
            width: '900px', // Width to fit 3 slides
            position: 'relative',
            cursor: isDragging ? 'grabbing' : 'grab',
          }}
          onMouseDown={handleDragStart}
          onMouseUp={handleDragEnd}
          onMouseLeave={handleDragEnd}
          onMouseMove={handleDragMove}
          onTouchStart={handleDragStart}
          onTouchEnd={handleDragEnd}
          onTouchMove={handleDragMove}
        >
          <div
            style={{
              display: 'flex',
              transition: 'transform 0.3s ease-in-out',
              transform: `translateX(-${currentIndex * 300}px)`,
            }}
          >
            {teamData.map((member, index) => (
              <div
                key={index}
                style={{
                  position: 'relative',
                  minWidth: '300px', // Width of each image card
                  height: '400px', // Height of each image card
                  margin: '0 10px',
                  overflow: 'hidden',
                  borderRadius: '10px',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                }}
              >
                <img
                  src={member.img}
                  alt={member.name}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    borderRadius: '10px',
                  }}
                />
                {/* Overlay on hover */}
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    opacity: 0,
                    transition: 'opacity 0.3s ease',
                    borderRadius: '10px',
                  }}
                  className="hover-overlay"
                >
                  <FaInstagram style={{ color: 'white', fontSize: '2rem' }} />
                </div>
                {/* Bottom Patti */}
                <div
                  style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.8)',
                    color: 'white',
                    textAlign: 'center',
                    padding: '10px 0',
                    fontSize: '14px',
                  }}
                >
                  <div style={{ fontWeight: 'bold' }}>{member.name}</div>
                  <div>{member.designation}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <style>
        {`
          .hover-overlay {
            opacity: 0;
          }
          .hover-overlay:hover {
            opacity: 1;
          }
        `}
      </style>
    </>
  );
};

export default Team;
